export default {
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setUnread(state, payload) {
    state.unreadCount = payload;
  },
  setUnreadMes(state, payload) {
    state.unreadMes = payload;
  },
  pushNotification(state, payload) {
    state.notifications.push(payload);
    ++state.unreadCount;
  },
  decreaseCounter(state) {
    --state.unreadMes;
  },
};
